import { ROUTES, TABS } from "../../constants";

export const routes = [
  {
    link: ROUTES.HOME,
    label: TABS.HOME,
  },
  {
    link: ROUTES.SERVICES,
    label: TABS.SERVICES,
  },
  {
    link: ROUTES.WORKS,
    label: TABS.WORKS,
  },
  {
    link: ROUTES.BRANDS,
    label: TABS.BRANDS,
  },
  {
    link: ROUTES.CONTACTME,
    label: TABS.CONTACTME,
  },
];

export const letsTalk = {
  link: ROUTES.LETSTALK,
  label: TABS.LETSTALK,
};
